import DashboardContentHeading from '../DashboardContentHeading/DashboardContentHeading';
import FavoritesCard from './FavoritesCard/FavoritesCard';
import classes from './MyFavorites.module.scss';
import AuthContext from "../../../store/auth-context";
import { getCarFavourites } from '../../../services/index';
import React, {useEffect, useState, useContext, useCallback} from 'react';
import EmptyContentCard from '../../Layout/EmptyContentCard';
import { Link } from 'react-router-dom';

const FavoritesSkeleton = () => {
    return (
        <div className={classes.skeletonCard}>
            <div className={classes.imageContainer}>
                <div className={classes.image}></div>
            </div>
            <div className={classes.content}>
                <div className={classes.title}></div>
                <div className={classes.details}>
                    <div className={classes.detail}></div>
                    <div className={classes.detail}></div>
                    <div className={classes.price}></div>
                </div>
            </div>
        </div>
    );
};

const MyFavorites = () => {
    const authCtx = useContext(AuthContext);
    const [isFavoriteEmpty, setIsFavoriteEmpty] = useState(true);
    const [isLoading, setLoading] = useState(false);
    const [favoriteCars, setFavoriteCars] = useState([]);
    const totalCarsToShow = 9;
    const page = 1;

    const fetchData = useCallback(() => {
        setLoading(true);
        const payload = `pageNo=${page}&size=${totalCarsToShow}`;
        getCarFavourites(payload).then((res) => {
          setLoading(false);
          if (res?.message === "Success") {
            console.log("res", res);
            if(res?.data.length > 0){
            setFavoriteCars(res?.data);
            setIsFavoriteEmpty(false);
            }else{
                setIsFavoriteEmpty(true);
            }
          }else{
            setIsFavoriteEmpty(true);
          }
        });
      }, []);

      useEffect(() => {
        if(authCtx.isLoggedIn){
        fetchData();
        }
      }, [fetchData, authCtx.isLoggedIn]);

    return (
        <div className={classes.MyFavorites}>
            <div className={classes.MyFavoritesHeader}>
                <DashboardContentHeading iconText='favorites' />
                <Link to="/garage?source=auction&tab=favorites">All Favorites</Link>
            </div>
            {isLoading ? (
                <div className={classes.MyFavoritesCardContainer}>
                    {[...Array(2)].map((_, index) => (
                        <FavoritesSkeleton key={index} />
                    ))}
                </div>
            ) : isFavoriteEmpty ? (
                <div style={{display:"flex",justifyContent:"center", maxHeight:"300px"}}>
                    <EmptyContentCard />
                </div>
            ) : (
                <div className={classes.MyFavoritesCardContainer}>
                    {favoriteCars.map((content, index) => (
                        <FavoritesCard key={index} content={content}/>
                    ))}
                </div>
            )}
        </div>
    )
}

export default MyFavorites;